import { useState, useRef } from "react";
import PropTypes from "prop-types";
import uploadIcon from "./assets/upload-icon.svg";

const FormSection = ({ applyFormRef }) => {
  const fileInputRef = useRef(null);

  const [formData, setFormData] = useState({
    name: "",
    mobile_number: "",
    email: "",
    cover_letter: "",
    resume: null,
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});

const validateForm = () => {
  const newErrors = {};

  if (!formData.name.trim()) {
    newErrors.name = "Name is required";
  }

  if (!formData.mobile_number.trim()) {
    newErrors.mobile_number = "Phone number is required";
  }

  if (!formData.email.trim()) {
    newErrors.email = "Email is required";
  }

  if (!formData.cover_letter.trim()) {
    newErrors.cover_letter = "Cover letter is required";
  }

  // ✅ ADD THIS
  if (!formData.resume) {
    newErrors.resume = "Resume is required";
  }
if (formData.name && !/^[A-Za-z\s]+$/.test(formData.name)) {
  newErrors.name = "Only letters allowed";
}

if (formData.mobile_number && !/^\d+$/.test(formData.mobile_number)) {
  newErrors.mobile_number = "Only numbers allowed";
}
  setErrors(newErrors);

  return Object.keys(newErrors).length === 0;
};

const handleChange = (event) => {
  const { name, value, files } = event.target;

  // ✅ Resume
  if (name === "resume") {
    setFormData((prev) => ({
      ...prev,
      resume: files?.[0] || null,
    }));

    setErrors((prev) => ({
      ...prev,
      resume: "",
    }));

    return;
  }

  // ✅ Name → only letters & space
  if (name === "name") {
    if (/^[A-Za-z\s]*$/.test(value)) {
      setFormData((prev) => ({
        ...prev,
        name: value,
      }));
    }
  }

  // ✅ Mobile → only numbers
  else if (name === "mobile_number") {
    if (/^\d*$/.test(value)) {
      setFormData((prev) => ({
        ...prev,
        mobile_number: value,
      }));
    }
  }

  // ✅ Other fields
  else {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  // ✅ clear error while typing
  setErrors((prev) => ({
    ...prev,
    [name]: "",
  }));
};

 
  const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

const handleSubmit = async (event) => {
  event.preventDefault();
  setMessage("");

  // ✅ ADD THIS
  if (!validateForm()) return;

  setLoading(true);

    try {
      let base64Resume = "";

      if (formData.resume) {
        base64Resume = await fileToBase64(formData.resume);
      }

      const payload = {
        name: formData.name,
        mobile_number: formData.mobile_number,
        email: formData.email,
        cover_letter: formData.cover_letter,
        resume: base64Resume,
      };

      const response = await fetch(
        "https://api.app.mawalog.com/v1.2/job_apply",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (result.success) {
        setMessage("Application submitted successfully!");
        setFormData({
          name: "",
          mobile_number: "",
          email: "",
          cover_letter: "",
          resume: null,
        });

        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      } else {
        setMessage("Submission failed.");
      }
    } catch (error) {
  console.error(error);
  setMessage("Network error or server issue.");

    } finally {
      setLoading(false);
    }
  };

  return (
    <div ref={applyFormRef} className="bg-[#F6F9FC] px-4 md:px-16 py-12">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-3xl sm:text-4xl font-semibold text-gray-900 mb-4">
          Apply for this role
        </h2>

        <p className="text-gray-600 mb-8">
          Please fill in your personal details below to apply for this role.
        </p>

        <form
          onSubmit={handleSubmit}
          className="space-y-6 bg-white p-6 rounded-xl shadow-md"
        >
          <div>
            <label className="block text-[17px] font-medium text-gray-800 mb-2">
              Upload your resume/cv
            </label>

            <div className="border border-dashed border-gray-300 rounded-md p-6 text-center bg-[#FCFCFC]">
              <p className="font-semibold text-gray-700 mb-1">
                Choose a file or drag & drop it here
              </p>

              <p className="text-sm text-gray-400 mb-4">
                Only .doc, .docx, .pdf, .odt, .rtf
              </p>

              <label
                htmlFor="resume"
                className="inline-flex items-center gap-2 px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-full cursor-pointer"
              >
                <img src={uploadIcon} alt="Upload" className="w-5 h-5" />
                Upload
              </label>

              <input
                ref={fileInputRef}
                id="resume"
                name="resume"
                type="file"
                accept=".doc,.docx,.pdf,.odt,.rtf"
                className="hidden"
                onChange={handleChange}
                
              />

              {formData.resume && (
                <p className="text-sm text-green-600 mt-2">
                  {formData.resume.name}
                </p>
              )}
              {errors.resume && (
  <p className="text-red-500 text-sm mt-2">
    {errors.resume}
  </p>
)}
            </div>
          </div>

          <div>
            <label htmlFor="name" className="block text-[15px] font-medium text-gray-700 mb-1">
              Name
            </label>

            <input
              id="name"
              type="text"
              name="name"
              placeholder="Your name"
              value={formData.name}
              onChange={handleChange}
              
              className="w-full border border-gray-300 rounded-md p-3 focus:border-green-600 focus:outline-none transition"
            />
            {errors.name && (
  <p className="text-red-500 text-sm mt-1">
    {errors.name}
  </p>
)}
          </div>

          <div>
            <label htmlFor="mobile_number" className="block text-[15px] font-medium text-gray-700 mb-1">
              Phone number
            </label>

            <input
            id="mobile_number"
              type="tel"
              name="mobile_number"
              placeholder="Your phone number"
              value={formData.mobile_number}
              onChange={handleChange}
              
              className="w-full border border-gray-300 rounded-md p-3 focus:border-green-600 focus:outline-none transition"
            />
            {errors.mobile_number && (
  <p className="text-red-500 text-sm mt-1">
    {errors.mobile_number}
  </p>
)}
          </div>

          <div>
            <label htmlFor="email" className="block text-[15px] font-medium text-gray-700 mb-1">
              Email
            </label>

            <input
            id="email"
              type="email"
              name="email"
              placeholder="Your email address"
              value={formData.email}
              onChange={handleChange}
              
              className="w-full border border-gray-300 rounded-md p-3 focus:border-green-600 focus:outline-none transition"
            />
            {errors.email && (
  <p className="text-red-500 text-sm mt-1">
    {errors.email}
  </p>
)}
          </div>

          <div>
            <label htmlFor="cover_letter" className="block text-[15px] font-medium text-gray-700 mb-1">
              Cover letter
            </label>

            <textarea
            id="cover_letter"
              name="cover_letter"
              rows="4"
              placeholder="Write your message here..."
              value={formData.cover_letter}
              onChange={handleChange}
              
              className="w-full border border-gray-300 rounded-md p-3 focus:border-green-600 focus:outline-none transition"
            />
            {errors.cover_letter && (
  <p className="text-red-500 text-sm mt-1">
    {errors.cover_letter}
  </p>
)}
          </div>

          <div className="flex items-start">
            <input
              id="consent"
              type="checkbox"
              
              className="mt-1 mr-2"
            />

            <label htmlFor="consent" className="text-sm text-gray-600">
              By using this form you agree with the storage and handling of your
              data by this website. *
            </label>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-3 px-6 rounded-md transition"
          >
            {loading ? "Submitting..." : "SUBMIT"}
          </button>

          {message && (
            <p className="text-center text-sm mt-4 text-gray-700">
              {message}
            </p>
          )}
        </form>
      </div>
    </div>
  );
};

FormSection.propTypes = {
  applyFormRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }).isRequired,
};

export default FormSection;
